import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid g-2 web5__rowcard" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "col-4"
}
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 1,
  class: "col-4"
}
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "row pt-4" }
const _hoisted_10 = {
  key: 0,
  class: "col-4"
}
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = {
  key: 1,
  class: "col-4"
}
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[20] || (_cache[20] = _createElementVNode("div", {
      class: "row",
      style: {"min-height":"80px"}
    }, [
      _createElementVNode("div", { class: "col" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col -2" }, null, -1)),
      (_ctx.IsInFunctionalRoles('MasterAdmin,MonitoringEasy,OnlineCheckEasy,MonitoringProfessional,OnlineCheckProfessional'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "card-header" }, "Monitoring", -1)),
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "card-title" }, "Geräte Übersichten und Wartung", -1)),
                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "card-text" }, "Hier erhalten Sie übersichten über Ihre Geräte.", -1)),
                _createVNode(_component_router_link, { to: { name: 'ControlCenter'} }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("Zum Monitoring")
                  ])),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.IsInFunctionalRoles('MasterAdmin,DokumentenverwaltungProfessional'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "card-header" }, "Dokumentenverwaltung", -1)),
              _createElementVNode("div", _hoisted_8, [
                _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "card-title" }, "Gebäudepläne", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "card-text" }, "Überprüfen der aktuellen Gebäudepläne", -1)),
                _createVNode(_component_router_link, { to: { name: 'DocumentManagement'} }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Anzeigen")
                  ])),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col -2" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col -2" }, null, -1)),
      (_ctx.IsInFunctionalRoles('MasterAdmin,Kundendienst'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[13] || (_cache[13] = _createElementVNode("h5", { class: "card-header" }, "Kundendienst", -1)),
              _createElementVNode("div", _hoisted_12, [
                _cache[11] || (_cache[11] = _createElementVNode("h5", { class: "card-title" }, "Störungsmanagement", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "card-text" }, "Störungen erfassen und Rücksendeschein erzeugen", -1)),
                _createVNode(_component_router_link, { to: { name: 'auftrag'} }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode("Melden Sie hier Ihre Störung")
                  ])),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.IsInFunctionalRoles('MasterAdmin'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "card-header" }, "Rechnungsinfo", -1)),
              _createElementVNode("div", _hoisted_15, [
                _cache[15] || (_cache[15] = _createElementVNode("h5", { class: "card-title" }, "Rechnungsinfo anzeigen", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "card-text" }, "SOS24Aid-Stammdatenblatt", -1)),
                _createVNode(_component_router_link, { to: { name: 'ShowDeviceData'} }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode("Erstellen")
                  ])),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col -2" }, null, -1))
    ])
  ]))
}